// extracted by mini-css-extract-plugin
module.exports = {"honeypot":"Honeypot_honeypot__SDVEq"};